<div class="error-container" role="status" aria-live="polite">
    <div class="error-visual">
        <img alt="" class="error-image" src="assets/images/error_moon.webp">
    </div>
    <div class="error-text">
        <p class="error-kicker">{{ 'ERROR.GENERIC_KICKER' | translate }}</p>
        <h1>{{ 'ERROR.GENERIC_TITLE' | translate }}</h1>
        <p class="error-subtitle">{{ 'ERROR.GENERIC_SUBTITLE' | translate }}</p>
        <p class="error-message">{{ 'ERROR.GENERIC_MESSAGE' | translate }}</p>
        <button (click)="retry()" class="retry-button" type="button">
            <span aria-hidden="true">&#8635;</span>
            {{ 'ERROR.RETRY' | translate }}
        </button>
    </div>
</div>
